/* tslint:disable */
/* eslint-disable */
/**
 * Opus API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface OK
 */
export interface OK {
  /**
   *
   * @type {boolean}
   * @memberof OK
   */
  status: boolean
}

/**
 * Check if a given object implements the OK interface.
 */
export function instanceOfOK(value: object): value is OK {
  if (!('status' in value) || value['status'] === undefined) return false
  return true
}

export function OKFromJSON(json: any): OK {
  return OKFromJSONTyped(json, false)
}

export function OKFromJSONTyped(json: any, ignoreDiscriminator: boolean): OK {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
  }
}

export function OKToJSON(value?: OK | null): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
  }
}
